import { canv } from "@/canv/global";
import type { ShapeTextPart } from "@/shapeStorage/shapes/shape";
import { Shape } from "@/shapeStorage/shapes/shape";
import { getNewStartY } from "@/shapeStorage/utils";

export class ShapeTransaction extends Shape {
    width = 200;
    height = 128;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = ((width / 1.3) * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 6, null);

        this.updateTextDims(textPart);

        return { allowedWidth, allowedHeight };
    }

    draw(x: number, y: number, width: number, height: number) {
        const lineWidth = 1.5;
        const marginPercent = 0.15; // 15% от размера — расстояние от краёв

        // Сохраняем текущее значение lineWidth
        const oldLineWidth = canv.ctx.lineWidth;
        canv.ctx.lineWidth = lineWidth;

        // Вычисляем пропорциональный отступ
        const horizontalMargin = width * marginPercent;
        const verticalMargin = height * marginPercent;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y);
        canv.ctx.lineTo(x + width, y);
        canv.ctx.lineTo(x + width, y + height);
        canv.ctx.lineTo(x, y + height);
        canv.ctx.lineTo(x, y);

        const x2 = x + horizontalMargin;
        const y2 = y + verticalMargin;
        canv.ctx.moveTo(x2, y2);
        canv.ctx.lineTo(x + width - horizontalMargin, y2);
        canv.ctx.lineTo(x + width - horizontalMargin, y + height - verticalMargin);
        canv.ctx.lineTo(x2, y + height - verticalMargin);
        canv.ctx.lineTo(x2, y2);

        canv.ctx.closePath();

        // Восстанавливаем lineWidth
        canv.ctx.lineWidth = oldLineWidth;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            stroke = "#7C7C91";
            fill = "";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 15;
        } else if (reason === "voteResult") {
            width = 200;
            height = 128;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m23 4.25c.4142 0 .75.33579.75.75v14c0 .4142-.3358.75-.75.75h-22c-.414214 0-.75-.3358-.75-.75v-14c0-.41421.335786-.75.75-.75zm-21.25 14h20.5v-12.5h-20.5zm17.5635-10.26758c.414.00014.7498.336.75.75v6.53518c-.0002.414-.336.7498-.75.75h-14.62698c-.41406-.0001-.74987-.336-.75-.75v-6.53518c.00016-.41403.33596-.74991.75-.75zm-13.87698 6.53518h13.12698v-5.03518h-13.12698z"
                fill="${stroke}"/>
             </svg>
            `;
    }
}
